import { ctaLoginSettleId } from "@/assets/googleTrackIds";
import { useAppDispatch, useAppSelector, useAppTranslation } from "@/utils";
import { Button, Card, Flex, Grid, Typography, useMessagedAsyncRetry } from "@payping/web-components";
import { Link } from "react-router-dom";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { getCashOutOverview } from "@payping/redux/actions";

import { CuToman, SettlmentPic } from "@payping/icons";
import { usePermission } from "@/utils/usePermission";
import { permissionsList } from "@/router/types";
import { DashboardRoutes } from "@/router";
// import classNames from "classnames";
// import style from "./style.module.scss";

const SettlementCard = () => {
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();
  const { md } = Grid.useBreakpoint();
  const isSettlementGranted = usePermission([permissionsList.settlementOverview]);
  const cashoutOverview = useAppSelector((state) => state.cashOuts.overview);

  useMessagedAsyncRetry(() => dispatch(getCashOutOverview()), [], {
    success: false,
  });

  if (!isSettlementGranted || !cashoutOverview) return null;

  return (
    <Card.Ant className="tw-w-full">
      <Flex gap="16px" wrap="wrap">
        {md ? null : (
          <div className={"tw-flex tw-w-full tw-justify-center"}>
            <SettlmentPic width={"100%"} height={"150px"} />
          </div>
        )}
        <Flex gap="16px" vertical>
          <Typography.Title type={"secondary"} className="!tw-m-0 tw-mb-4" level={4}>
            {t("overview.settlementCard.title")}
          </Typography.Title>
          <Flex vertical gap="8px">
            <Typography.Text>{t("overview.settlementCard.holding")}</Typography.Text>
            <Flex align="center">
              <Typography.Title
                className="!tw-m-0"
                level={5}
              >{`${formatLocalizedNumber({ value: cashoutOverview.withdrawableBalance ?? 0 })}`}</Typography.Title>
              <CuToman width={24} height={24} />
            </Flex>
          </Flex>
          <div data-google-track={ctaLoginSettleId}>
            <Link to={DashboardRoutes.settlement.root.url}>
              <Button type="primary">{t("overview.settlementCard.login")}</Button>
            </Link>
          </div>
        </Flex>
        {md ? (
          <div className="tw-mr-auto">
            <SettlmentPic width={"150px"} height={"150px"} />
          </div>
        ) : null}
      </Flex>
    </Card.Ant>
  );
};

export default SettlementCard;
